export class AccountDetails {
  constructor() {
    this.id = null;
    this.interest_rate = null;
    this.overDraft = null;
    this.creditLimit = null;
    this.minimumPayment = null;
    this.minimumPaymentDate = null;
    this.lastStatementBalance = null;
    this.lastStatementDate = null;
    this.statementFlag = null;
    this.balances = null;
    this.iban = null;
    this.bic = null;
  }
}
export default AccountDetails;
